// React
import { memo, useMemo } from "react";
import { ReactSVG } from "react-svg";

import { NAMES_SHOWN } from "./consts";
import { buildAllocationLabel, splitAllocationTargets } from "./transformations";
import { InvoiceIncomingAllocationBadgeProps } from "./types";

/**
 * Stanje raspodjele uz naslov popisa stavki — na što je račun otišao, odnosno upozorenje da
 * troškovi još čekaju. Koja je stavka neraspoređena vidi se po žutom retku.
 */
const InvoiceIncomingAllocationBadge: React.FC<InvoiceIncomingAllocationBadgeProps> = (props) => {
  const { allocations, isAllocatable } = props;

  // Stavka može otići na vozilo ili na trošak tvrtke — oboje se imenuje zasebno, jer se i čita
  // drukčije: „na vozila ZG123" nasuprot „na troškove tvrtke Uredski materijal".
  const targets = useMemo(() => splitAllocationTargets(allocations), [allocations]);

  const hasTargets = targets.vehicles.length > 0 || targets.expenseTypes.length > 0;

  if (!hasTargets) {
    // Prije odobrenja raspodjela nije ni na redu, pa nema što upozoravati.
    if (!isAllocatable) return null;

    return (
      <span
        className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 text-amber-800 border border-amber-300 px-3 py-1 text-xs font-medium"
        title="Troškovi ovog računa još nisu raspoređeni na vozila."
      >
        <ReactSVG src="/media/icons/warning.svg" className="w-3.5 h-3.5 text-amber-700" />
        Troškovi nisu raspoređeni
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center rounded-full bg-slate-100 text-slate-600 border border-slate-200 px-3 py-1 text-xs font-medium"
      title={buildAllocationLabel(targets, targets.vehicles.length + targets.expenseTypes.length)}
    >
      {buildAllocationLabel(targets, NAMES_SHOWN)}
    </span>
  );
};

export default memo(InvoiceIncomingAllocationBadge);
